<template>
  <div class="storageInventoryDaily">
    <h2>库存日成本表</h2>
    <el-form :inline="true">
      <el-form-item label="日期">
        <el-date-picker v-model="searchParam.date" style="width: 220px;" />
      </el-form-item>
      <el-form-item>
        <el-switch v-model="searchParam.hasStorage" active-text="区分仓储" />
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="commitFindList()">搜索</el-button>
          <el-button @click="resetSearchParam()">重置</el-button>
        </el-button-group>
      </el-form-item>
      <el-form-item>
        <el-button style="width: 50px;" @click="colIndex++">{{ colIndex % 3 == 0 ? "-" : (colIndex % 3 == 1 ? "→" : "←") }}</el-button>
      </el-form-item>
    </el-form>
    <el-row :gutter="20">
      <el-col :span="colIndex % 3 == 0 ? 12 : (colIndex % 3 == 1 ? 22 : 2)">
        <el-table :data="data.inList" border style="height: calc(100vh - 270px);" show-summary :summary-method="summaryIn">
          <el-table-column prop="storage" label="仓储" width="80" show-overflow-tooltip />
          <el-table-column prop="product" label="煤矿品名" width="130" show-overflow-tooltip />
          <el-table-column prop="inQuantity" label="入库数量" show-overflow-tooltip align="right">
            <template #default="scope">
              {{ math.formatNumber(scope.row.inQuantity) }}
            </template>
          </el-table-column>
          <el-table-column label="煤矿费用" show-overflow-tooltip align="right">
            <template #default="scope">
              <el-text>{{ math.formatNumber(scope.row.productAmount) }}</el-text>
            </template>
          </el-table-column>
          <el-table-column label="实付运费" show-overflow-tooltip align="right">
            <template #default="scope">
              <!-- 实付运费（扣除后运费小计）与用于计算运费单价的运输总价不同 -->
              <el-text>{{ math.formatNumber(scope.row.transportAmountAfterDeduction) }}</el-text>
            </template>
          </el-table-column>
          <el-table-column label="单价" show-overflow-tooltip align="right">
            <template #default="scope">
              <el-text>{{ math.formatNumber(math.halfUp(scope.row.productAmount / scope.row.inQuantity, 2)) }}</el-text>
            </template>
          </el-table-column>
          <el-table-column label="运费单价" show-overflow-tooltip align="right">
            <template #default="scope">
              <el-text>{{ math.formatNumber(math.halfUp(scope.row.transportAmount / scope.row.inQuantity, 2)) }}</el-text>
            </template>
          </el-table-column>
          <el-table-column prop="afterQuantity" label="累计入库" show-overflow-tooltip align="right">
            <template #default="scope">
              {{ math.formatNumber(scope.row.afterQuantity) }}
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="colIndex % 3 == 0 ? 12 : (colIndex % 3 == 1 ? 2 : 22)">
        <el-table :data="data.outList" border style="height: calc(100vh - 270px);" show-summary :summary-method="summaryOut">
          <el-table-column prop="storage" label="仓储" width="80" show-overflow-tooltip />
          <el-table-column prop="product" label="煤矿品名" width="130" show-overflow-tooltip />
          <el-table-column prop="outQuantity" label="出库数量" show-overflow-tooltip align="right">
            <template #default="scope">
              {{ math.formatNumber(scope.row.outQuantity) }}
            </template>
          </el-table-column>
          <el-table-column label="实时单价" show-overflow-tooltip align="right">
            <template #default="scope">
              <el-text>{{ math.formatNumber(math.halfUp(scope.row.inventoryProductAmount / scope.row.outQuantity, 2)) }}</el-text>
            </template>
          </el-table-column>
          <el-table-column label="实时运价" show-overflow-tooltip align="right">
            <template #default="scope">
              <el-text>{{ math.formatNumber(math.halfUp(scope.row.inventoryTransportAmount / scope.row.outQuantity, 2)) }}</el-text>
            </template>
          </el-table-column>
          <el-table-column prop="afterQuantity" label="累计出库" show-overflow-tooltip align="right">
            <template #default="scope">
              {{ math.formatNumber(scope.row.afterQuantity) }}
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import api from '../../apis/api'
import cache from '../../utils/cache'
import util from '../../utils/util'
import math from '../../utils/math'

const router = useRouter()

const data = reactive({
  inList: [],
  inData: {},
  outList: [],
  outData: {},
})

const colIndex = ref(0)

const show = reactive({
  storageList: [],
})
api.get('/backend/dict/getByCode', { params: { code: 'storage' } }).then(res => {
  show.storageList = res.dictList
})

const now = new Date()
const yesterday = new Date(now.getTime() - 1 * 24 * 60 * 60 * 1000)

const searchParam = reactive({})
const resetSearchParam = () => {
  searchParam.date = yesterday
  searchParam.hasStorage = true
}
resetSearchParam()

const commitFindInList = () => {
  const params = {}
  params.hasStorage = searchParam.hasStorage
  params.receiveDate = util.parseTime(searchParam.date, '{y}-{m}-{d}')
  api.get('/backend/inventory/inAll', { params: params }).then(res => {
    data.inList = res.list
    data.inData = res.data
  })
}

const commitFindOutList = () => {
  const params = {}
  params.hasStorage = searchParam.hasStorage
  params.sendDate = util.parseTime(searchParam.date, '{y}-{m}-{d}')
  api.get('/backend/inventory/outAll', { params: params }).then(res => {
    data.outList = res.list
    data.outData = res.data
  })
}

const commitFindList = () => {
  data.inList = []
  data.outList = []
  commitFindInList()
  commitFindOutList()
}

const summaryIn = () => {
  return ['',
    '',
    math.formatNumber(data.inData.inQuantity),
    math.formatNumber(data.inData.productAmount),
    math.formatNumber(data.inData.transportAmountAfterDeduction),
    math.formatNumber(data.inData.averageProductPrice),
    math.formatNumber(data.inData.averageTransportPrice),
    '']
}

const summaryOut = () => {
  return ['',
    '',
    math.formatNumber(data.outData.outQuantity),
    math.formatNumber(data.outData.inventoryAverageProductPrice),
    math.formatNumber(data.outData.inventoryAverageTransportPrice),
    '']
}
</script>

<style lang="less"></style>